import { api } from '../../../services/api'

/**
 * Confirm/check new user logged phone number.
 *
 * @endpoint POST /api/me/verify/phone_number/{phoneNumber}/check
 * @scope shared
 * @see https://flecto.dev/api-4724202
 */
export async function verifyUserPhoneNumberCheck(
  phoneNumber: string,
  payload: VerifyUserPhoneNumberCheckPayload
): Promise<void> {
  await api.post(`/api/me/verify/phone_number/${phoneNumber}/check`, payload)
}

export type VerifyUserPhoneNumberCheckPayload = {
  code: string
}
